import { deviceDashboardTypes } from "../actions/singleDevice";

const initialState = {
  isBLE: true,
  isLoading: false,
  isPlaying: false,
  isFullScreenMode: false,
  startDateTime: "",
  endDateTime: "",
  deviceData: {
    name: null,
    orgId: null,
    organizationName: null,
    siteId: null,
    locationName: null,
    healthStatus: null,
    connectionStatus: null,
    assetStatus: null,
    activeStatus: null
  },
  data: [],
  error: null,
};

const deviceBLEDashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case deviceDashboardTypes.FETCH_REQUEST:
      return {
        ...state,
        isLoading: true,
        startDateTime: action.payload.startDateTime,
        endDateTime: action.payload.endDateTime,
      };
    case deviceDashboardTypes.DEVICE_DATA_UPDATE_REQUEST:
      return {
        ...state,
        isBLE: action.payload.isBLE,
        deviceData: {
          ...state.deviceData,
          ...action.payload.deviceData,
        },
      };
    case deviceDashboardTypes.FETCH_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: action.payload,
        error: null,
      };
    case deviceDashboardTypes.FETCH_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default deviceBLEDashboardReducer;
